import { buildFlags } from '@sketch/components';
import { defaultFlags } from '@sketch/constants';
export { defaultFlags } from '@sketch/constants';

const { Flag, FlagsContext, FlagsProvider, useFlag } = buildFlags(defaultFlags);

export { Flag, FlagsContext, FlagsProvider, useFlag };
